// =========================================================
// * Volt React Dashboard
// =========================================================

// * Product Page: https://themesberg.com/product/dashboard/volt-react
// * Copyright 2021 Themesberg (https://www.themesberg.com)
// * License: MIT License (https://themesberg.com/licensing)

// * Designed and coded by https://themesberg.com

// =========================================================

// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. Please contact us to request a removal.

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// core styles
import './scss/volt.scss';

// vendor styles
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-datetime/css/react-datetime.css';

import { Provider } from 'react-redux';
import { reduxStore } from './reduxToolkit';
import App from './App';
import ScrollToTop from './components/ScrollToTop';
import ReactNotifications from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import Loader from 'components/Loader';

ReactDOM.render(
    <Provider store={reduxStore}>
        <BrowserRouter>
            <ScrollToTop />
            <ReactNotifications />
            <Loader />
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
